import { createApp } from 'vue';
import App from './App.vue';
import './styles/base.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(fab, fas);

// Fades elements in as they scroll into view; also tracks the cursor for the card glow.
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
);

const app = createApp(App);
app.component('font-awesome-icon', FontAwesomeIcon);
app.directive('reveal', {
  mounted(el, binding) {
    el.classList.add('reveal');
    if (binding.value) el.style.setProperty('--delay', `${binding.value}ms`);
    observer.observe(el);
  },
});
app.mount('#app');

document.addEventListener('pointermove', (e) => {
  const card = e.target.closest && e.target.closest('.card');
  if (!card) return;
  const r = card.getBoundingClientRect();
  card.style.setProperty('--mx', `${e.clientX - r.left}px`);
  card.style.setProperty('--my', `${e.clientY - r.top}px`);
});
